import { useAiAltDealStructureSlideout } from '../AiAltDealStructureSlideout';

export const useAltDealStructureLink = (onLabelClick?: () => void) => {
    const { showAltDealStructures } = useAiAltDealStructureSlideout();

    return () => {
        showAltDealStructures();
        onLabelClick?.();
    };
};
